import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const farmAnimalUpdate: ImportTypeConfig = {
  type: 'farm-animal-update',
}
